import React, { useState, useEffect, useRef } from 'react';

import formatPrice from '@ibibo/format-price';
import CalendarIcon from './assets/CalendarIcon';

import { dateComp, getDateFromYYYYMMDDString, MONTHS } from './fareTrendsUtils';
import { FixedSizeList as List } from 'react-window';
import * as S from './barChart.styles';

const FareTrendsBarChart = props => {
  const { fareTrendsData, showMonth, selectedDate, selectOtherDate, openCalendar } = props;

  const [displayMonth, setDisplayMonth] = useState(() => {
    if (Array.isArray(fareTrendsData) && fareTrendsData.length && fareTrendsData[0].date) {
      const dateObj = getDateFromYYYYMMDDString(fareTrendsData[0].date);
      const month = MONTHS[dateObj.getMonth()];
      return month || '';
    }
    return '';
  });

  const priceArray = fareTrendsData.map(fareObj => fareObj.price);
  const maxPrice = Math.max.apply(null, priceArray);
  const minPrice = Math.min.apply(null, priceArray);
  const minHeightPercent = 35;
  let currentFareWidth = 0;
  const barWidth = 56;
  const fareTrendsRef = useRef();

  useEffect(() => {
    scrollDivider();
    onScroll();
    const activeSelectedDateInd = fareTrendsData.findIndex(fare => fare.date == selectedDate);
    if (fareTrendsRef.current) {
      fareTrendsRef.current.scrollToItem(activeSelectedDateInd, 'start');
    }
  }, [currentFareWidth]);

  const scrollDivider = () => {
    if (currentFareWidth) {
      /* 2*barWidth is done to include two show two more fares before selected fare. */
      document.getElementById('fareTrend').scrollTo(currentFareWidth - 2 * barWidth + barWidth, 0);
    }
  };

  const onScroll = () => {
    const eles = document.getElementsByClassName('fareTrendBar');
    for (let i = 0; i < eles.length; i++) {
      const ele = eles[i];
      const leftPos = ele.getBoundingClientRect().left;
      if (leftPos > 0) {
        const date = ele.id;
        const dateObj = getDateFromYYYYMMDDString(date);
        const month = MONTHS[dateObj.getMonth()];
        setDisplayMonth(month);
        return;
      }
    }
  };

  const fareTrendsList = ({ index, style }) => {
    const fareObj = fareTrendsData[index];
    const heightPercent = ((fareObj.price - minPrice) / (maxPrice - minPrice)) * 100;
    const finalHeightPercent = heightPercent * ((100 - minHeightPercent) / 100) + minHeightPercent;
    const isSelectedDate = selectedDate && selectedDate === fareObj.date;
    const isLowest = fareObj.price === minPrice;
    const isMax = fareObj.price === maxPrice;
    if (isSelectedDate) {
      currentFareWidth = barWidth + index * barWidth;
    }

    return (
      <div
        style={{
          ...style,
          width: '100%'
        }}
      >
        <S.FareTrendWrap
          className="alignItemsEnd padT5 dF"
          style={{
            height: '77px',
            backgroundImage: 'linear-gradient(to bottom, #2276e3, #134280)'
          }}
          onScroll={onScroll}
          id="fareTrend"
        >
          <S.FTBlock
            className="padL5 padR5 flexCol justifyBetween alignItemsCenter fGS0 fareTrendBar"
            style={{ height: `${finalHeightPercent}%` }}
            id={fareObj.date}
            isSelected={isSelectedDate}
            onClick={() => selectOtherDate(fareObj.date, fareObj.price)}
          >
            <S.FTPrice
              isSelected={isSelectedDate}
              isLowest={isLowest && !isSelectedDate}
              isMax={isMax && !isSelectedDate}
              className="dF justifyStart"
            >
              <p>{formatPrice(fareObj.price)}</p>
            </S.FTPrice>
            <S.FTDay className="dF justifyEndtxtUpper">
              <p>{dateComp(fareObj.date, showMonth)}</p>
            </S.FTDay>
          </S.FTBlock>
        </S.FareTrendWrap>
      </div>
    );
  };

  return (
    <S.FareTrendContainer className="dF">
      <S.FTCal
        className="flexCol padT5 justifyEnd padL5 padR5 alignItemsCenter"
        onClick={openCalendar}
      >
        <CalendarIcon />
        <span className="padT10 txtUpper padB5 font10 white f600">{displayMonth}</span>
      </S.FTCal>
      <List
        height={80}
        width={__CLIENT__ ? window.innerWidth : 375}
        itemSize={57}
        itemCount={fareTrendsData.length}
        layout="horizontal"
        onScroll={onScroll}
        ref={fareTrendsRef}
      >
        {fareTrendsList}
      </List>
    </S.FareTrendContainer>
  );
};

export default FareTrendsBarChart;
